import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaTwitter, FaEnvelope } from 'react-icons/fa';

/**
 * 页脚组件
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer mt-auto py-4 bg-light">
      <div className="container-fluid px-4">
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span className="text-muted small">
              &copy; {currentYear} WebChangeAI. 保留所有权利.
            </span>
          </div>
          
          <div className="col-md-6">
            <div className="d-flex justify-content-md-end justify-content-center mt-md-0 mt-3">
              {/* 页脚链接 */}
              <div className="me-3">
                <Link to="/about" className="text-muted small text-decoration-none">关于我们</Link>
              </div>
              <div className="me-3">
                <Link to="/privacy" className="text-muted small text-decoration-none">隐私政策</Link>
              </div>
              <div className="me-3">
                <Link to="/terms" className="text-muted small text-decoration-none">服务条款</Link>
              </div>
              <div className="me-3">
                <Link to="/help" className="text-muted small text-decoration-none">帮助中心</Link>
              </div>
              
              {/* 社交媒体图标 */}
              <div className="ms-2 d-flex">
                <a 
                  href="https://github.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-muted me-3"
                  aria-label="GitHub"
                >
                  <FaGithub />
                </a>
                <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-muted me-3"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </a>
                <a 
                  href="mailto:contact@webchangeai.com" 
                  className="text-muted"
                  aria-label="Email"
                >
                  <FaEnvelope />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;